export const env = {
  MODE: import.meta.env.MODE,
  VITE_BUILD_IDENTIFIER:
    import.meta.env.VITE_BUILD_IDENTIFIER || 'non-production-build',

  // Sorted alphabetically below
  VITE_ASSET_DATA_SERVICE_BASE_PATH: import.meta.env
    .VITE_ASSET_DATA_SERVICE_BASE_PATH,
  VITE_CAPABILITY_BASE_PATH: import.meta.env.VITE_CAPABILITY_BASE_PATH,
  VITE_CIPHER_BASE_PATH: import.meta.env.VITE_CIPHER_BASE_PATH,
  VITE_ELOC_BASE_PATH: import.meta.env.VITE_ELOC_BASE_PATH,
  VITE_EVIDENCELOCKER_BASE_PATH: import.meta.env.VITE_EVIDENCELOCKER_BASE_PATH,
  VITE_INSIGHTS_BASE_PATH: import.meta.env.VITE_INSIGHTS_BASE_PATH,
  VITE_ITSM_BASE_PATH: import.meta.env.VITE_ITSM_BASE_PATH,
  VITE_MR_INFRA_RISK_BASE_PATH: import.meta.env.VITE_MR_INFRA_RISK_BASE_PATH,
  VITE_PREFERENCE_STORE_BASE_PATH: import.meta.env
    .VITE_PREFERENCE_STORE_BASE_PATH,
  VITE_RENDALL_BASE_PATH: import.meta.env.VITE_RENDALL_BASE_PATH,
  VITE_RTK_AUTH0_AUDIENCE: import.meta.env.VITE_RTK_AUTH0_AUDIENCE,
  VITE_RTK_AUTH0_CLIENT_ID: import.meta.env.VITE_RTK_AUTH0_CLIENT_ID,
  VITE_RTK_AUTH0_DOMAIN: import.meta.env.VITE_RTK_AUTH0_DOMAIN,
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  VITE_SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  VITE_TIP_SKU_BASE_PATH: import.meta.env.VITE_TIP_SKU_BASE_PATH,
  VITE_TRACK_PUBLIC_BASE_PATH: import.meta.env.VITE_TRACK_PUBLIC_BASE_PATH,
  VITE_USER_PROVISIONER_BASE_PATH: import.meta.env
    .VITE_USER_PROVISIONER_BASE_PATH,
};
